"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DarkIcon = exports.LightIcon = exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _TouchableOpacity = _interopRequireDefault(require("react-native-web/dist/cjs/exports/TouchableOpacity"));

var _faSolid = require("styled-icons/fa-solid");

var _Icon = require("../Icon");

function _templateObject7() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n          left: ", "px;\n          opacity: 1;\n        "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n          left: ", "px;\n          opacity: 0;\n        "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  position: absolute;\n  top: ", "px;\n  ", "\n  transition: all 500ms;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n          left: ", "px;\n          opacity: 0;\n        "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n          left: ", "px;\n          opacity: 1;\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  position: absolute;\n  top: ", "px;\n  ", "\n  transition: all 500ms;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  position: relative;\n  background-color: transparent;\n  width: ", "px;\n  height: ", "px;\n  border-width: ", "px;\n  border-color: ", ";\n  border-radius: 9999px;\n  display: flex;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var CONTAINER_HEIGHT = 40;
var BORDER_WIDTH = 3;
var INNER_GAP = 2;
var CONTAINER_WIDTH = 78;
var Container = (0, _styledComponents["default"])(_TouchableOpacity["default"])(_templateObject(), CONTAINER_WIDTH, CONTAINER_HEIGHT, BORDER_WIDTH, function (p) {
  return p.theme.colors.onBackground;
});
exports.Container = Container;
var LightIcon = (0, _styledComponents["default"])(_Icon.Icon).attrs(function (p) {
  return {
    IconComponent: _faSolid.Sun,
    size: CONTAINER_HEIGHT - BORDER_WIDTH * 2 - INNER_GAP * 2,
    color: p.theme.colors.onBackground
  };
})(_templateObject2(), INNER_GAP, function (p) {
  return p.currentTheme === "lightTheme" ? (0, _styledComponents.css)(_templateObject3(), INNER_GAP) : (0, _styledComponents.css)(_templateObject4(), CONTAINER_WIDTH - CONTAINER_HEIGHT);
});
exports.LightIcon = LightIcon;
var DarkIcon = (0, _styledComponents["default"])(_Icon.Icon).attrs(function (p) {
  return {
    IconComponent: _faSolid.Moon,
    size: CONTAINER_HEIGHT - BORDER_WIDTH * 2 - INNER_GAP * 2,
    color: p.theme.colors.onBackground
  };
})(_templateObject5(), INNER_GAP, function (p) {
  return p.currentTheme === "lightTheme" ? (0, _styledComponents.css)(_templateObject6(), INNER_GAP) : (0, _styledComponents.css)(_templateObject7(), CONTAINER_WIDTH - CONTAINER_HEIGHT);
});
exports.DarkIcon = DarkIcon;